module.exports = __webpack_public_path__ + "static/media/tooth.40877d99.svg";